import { Map, fromJS } from 'immutable';
import { SHOW_ERROR_POPUP, HIDE_ERROR_POPUP } from '../constants/error';
import { CREATE_ORDER_FAIL } from '../constants/order';

import {
  initPaymentFailAction,
  payUnitellerFailAction,
  pay3dsFailAction,
} from '../../../../store/payment/reducer';

const initialState = Map();

export default function (state = initialState, action) {
  switch (action.type) {
    case SHOW_ERROR_POPUP:
      return state.set('isOpened', true);
    case HIDE_ERROR_POPUP:
      return state.set('isOpened', false);
    case CREATE_ORDER_FAIL:
    case initPaymentFailAction.toString():
    case payUnitellerFailAction.toString():
    case pay3dsFailAction.toString(): {
      const { payload = {} } = action;
      return state.merge(
        fromJS({
          type: payload.type, // [order, ...]
          action: payload.action || null, // string
          title: payload.title, // string
          message: payload.message,
        }),
      );
    }

    default:
      return state;
  }
}
